import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DASHBOARD_WIDGETS_ENDPOINT } from '../api/api-endpoints';
import { RestApiService } from '../api/rest-api.service';
import {
  DashboardLayoutDocument,
  DashboardLayoutSaveRequest,
  DashboardOwnerScope,
} from './widget-and-graphs.models';

@Injectable({
  providedIn: 'root',
})
export class DashboardLayout {
  constructor(private readonly api: RestApiService) {}

  get(dashboardId: string, ownerScope: DashboardOwnerScope): Observable<DashboardLayoutDocument> {
    return this.api.get<DashboardLayoutDocument>(this.endpoint(dashboardId), {
      params: { owner_scope: ownerScope },
    });
  }

  save(
    dashboardId: string,
    request: DashboardLayoutSaveRequest,
  ): Observable<DashboardLayoutDocument> {
    return this.api.put<DashboardLayoutDocument>(this.endpoint(dashboardId), request);
  }

  private endpoint(dashboardId: string): string {
    return DASHBOARD_WIDGETS_ENDPOINT.replace('{0}', encodeURIComponent(dashboardId));
  }
}
